// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ClosableTag-ClosableTag-module__filtersBox--Lm91W {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-width: 0;
}
.src-components-ClosableTag-ClosableTag-module__filtersLabel--GX1Ws {
  color: rgba(0, 0, 0, 0.55);
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  flex-shrink: 0;
  padding-top: 1px;
}
.src-components-ClosableTag-ClosableTag-module__tagsViewport--Cw8OU {
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  max-height: 118px;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 8px;
}
.src-components-ClosableTag-ClosableTag-module__tagItem--kEf0A {
  display: grid;
  grid-template-columns: auto 20px;
  margin: 0;
  max-width: 100%;
  cursor: pointer;
}
.src-components-ClosableTag-ClosableTag-module__tagItem--kEf0A:hover {
  opacity: 0.9;
}
.src-components-ClosableTag-ClosableTag-module__tagLabel--H7vOy {
  overflow: hidden;
}
.src-components-ClosableTag-ClosableTag-module__actionBox--uIlAY {
  flex-shrink: 0;
  align-self: flex-start;
}
/*# sourceMappingURL=ClosableTag.module.css.map */`, "",{"version":3,"sources":["webpack://./ClosableTag.module.less","webpack://./src/components/ClosableTag/ClosableTag.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;ACCF;ADEA;EACE,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;ACAF;ADGA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;ACDF;ADIA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;ACFF;ADIE;EACE,YAAA;ACFJ;ADMA;EACE,gBAAA;ACJF;ADMA;EACE,cAAA;EACA,sBAAA;ACJF;AACA,iDAAiD","sourcesContent":[".filtersBox {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n}\n\n.filtersLabel {\n  color: rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  flex-shrink: 0;\n  padding-top: 1px;\n}\n\n.tagsViewport {\n  min-width: 0;\n  display: flex;\n  flex-wrap: wrap;\n  max-height: 118px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  gap: 8px;\n}\n\n.tagItem {\n  display: grid;\n  grid-template-columns: auto 20px;\n  margin: 0;\n  max-width: 100%;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.9;\n  }\n}\n\n.tagLabel {\n  overflow: hidden;\n}\n.actionBox {\n  flex-shrink: 0;\n  align-self: flex-start;\n}\n",".filtersBox {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n}\n.filtersLabel {\n  color: rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  flex-shrink: 0;\n  padding-top: 1px;\n}\n.tagsViewport {\n  min-width: 0;\n  display: flex;\n  flex-wrap: wrap;\n  max-height: 118px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  gap: 8px;\n}\n.tagItem {\n  display: grid;\n  grid-template-columns: auto 20px;\n  margin: 0;\n  max-width: 100%;\n  cursor: pointer;\n}\n.tagItem:hover {\n  opacity: 0.9;\n}\n.tagLabel {\n  overflow: hidden;\n}\n.actionBox {\n  flex-shrink: 0;\n  align-self: flex-start;\n}\n/*# sourceMappingURL=ClosableTag.module.css.map */"],"sourceRoot":""}]);
// Exports
export var filtersBox = `src-components-ClosableTag-ClosableTag-module__filtersBox--Lm91W`;
export var filtersLabel = `src-components-ClosableTag-ClosableTag-module__filtersLabel--GX1Ws`;
export var tagsViewport = `src-components-ClosableTag-ClosableTag-module__tagsViewport--Cw8OU`;
export var tagItem = `src-components-ClosableTag-ClosableTag-module__tagItem--kEf0A`;
export var tagLabel = `src-components-ClosableTag-ClosableTag-module__tagLabel--H7vOy`;
export var actionBox = `src-components-ClosableTag-ClosableTag-module__actionBox--uIlAY`;
export default ___CSS_LOADER_EXPORT___;
